let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aeEUI"), load("6wr18"), load("ffEVr"), load("5doAZ")]).then(() => parcelRequire('h8ksv'));